import { useStaticQuery, graphql } from "gatsby"
export const useMokkulaPlans = tec => {
  const result = useStaticQuery(
    graphql`
      query useMokkulaPlans {
        all: allMokkulaPlansJson(sort: { order: ASC, fields: price }) {
          edges {
            node {
              id
              img
              internetSpeed
              internetType
              name
              openFee
              price
              url
            }
          }
        }
        fourg: allMokkulaPlansJson(
          sort: { order: ASC, fields: price }
          filter: { internetType: { eq: "4g" } }
        ) {
          edges {
            node {
              id
              img
              internetSpeed
              internetType
              name
              openFee
              price
              url
            }
          }
        }
      }
    `
  )
  let plans = tec ? result.fourg.edges : result.all.edges
  return plans
}
